import shiptypeEditComponent from './shiptype.edit.component';

let shiptypeEditModule = angular.module('shiptypeedit', [
])

.component('shiptypeedit', shiptypeEditComponent)

.name;

export default shiptypeEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/edit/index.js